<template>
  <div class="container">
    <div v-for="(value, name, index) in details" :key="index">
      <template v-if="isObj(value)">
        <detail :details="value" />
      </template>
      <template v-else>
        <div class="mail">
          <el-row>
            <el-col :span="12">
              <span class="name">{{ name }}：</span>
            </el-col>
            <el-col :span="12">
              <span class="value">{{ value }}</span>
            </el-col>
          </el-row>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail',
  // props: ['details'],
  props: {
    details: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    isObj(value) {
      if (value != null) {
        return typeof value === 'object' && Object.keys(value).length
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.name {
  line-height: 48px;
}

.mail {
  background: #fafafa;
  margin-top: 5px;
  height: 48px;
  line-height: 48px;
  color: #606266;
  font-size: 14px;
  padding-left: 10px;
  border: 1px solid #ebeef5;
}
</style>
